import { render, staticRenderFns } from "./TechnologicalDevelopmentsCategoryHeader.vue?vue&type=template&id=5a67601e&scoped=true&"
import script from "./TechnologicalDevelopmentsCategoryHeader.vue?vue&type=script&lang=js&"
export * from "./TechnologicalDevelopmentsCategoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./TechnologicalDevelopmentsCategoryHeader.vue?vue&type=style&index=0&id=5a67601e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67601e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VIcon,VTextField})
